import React, { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';

import { color, image } from 'src/theme';

import styled from '@emotion/styled';
import { MAINTENANCE_SCREEN_ZINDEX } from '@/constants/zindex';
import { RegularText } from '@/components/text';

const Container = styled.div(({ theme }) => ({
  position: 'fixed',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#405B7D',
  width: '100vw',
  inset: 0,
  maxHeight: '100vh',
  height: '100vh',
  fontFamily: theme.fontFamily.primary,
  textTransform: 'uppercase',
  fontSize: '1.6rem',
  color: theme.color.white,
  fontWeight: theme.fontWeight.medium,
  zIndex: MAINTENANCE_SCREEN_ZINDEX,
  overflow: 'hidden',
}));

export const Wrapper = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '6rem 0',
}));

export const Title = styled.div(() => ({
  background: '#1B3757',
  padding: '2rem',
  textAlign: 'center',
  lineHeight: 1.8,
}));

export const Desc = styled.p(() => ({
  fontSize: '1.2rem',
  marginTop: '2rem',
  textAlign: 'center',
}));

const MaintenanceScreen = () => {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery({ minWidth: 1200 });

  useEffect(() => {
    document.body.style.cssText = `
      overflow-y: hidden;
      max-height: 100vh;
      width: 100%;
      `;
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      // NOTE: redirect to home every 30seconds

      navigate('/');
    }, 30000);

    return () => {
      clearInterval(timer);
    };
  }, [navigate]);

  return (
    <Container>
      <Wrapper>
        <object data={image.logoWhiteFull} width={isDesktop ? 360 : 300}>
          INSPIRE Entertainment Resort
        </object>

        <div>
          <Title>
            <RegularText color={color.base_white} fontSize={16} id="lang-performing-maintenance" />
          </Title>

          <Desc>
            <RegularText color={color.base_white} fontSize={12} id="lang-please-check-back-later" />
          </Desc>
        </div>
      </Wrapper>
    </Container>
  );
};

export default MaintenanceScreen;
